<template>
  <BaseDialog :title="infoDialogConfig.title" :visible="infoDialogVisible" append-to-body width="800px" @close="close">
    <template slot="body">
      <el-form :model="form" :rules="rules" ref="form" label-width="150px" label-position="right">
        <el-row>
          <!--<el-col :span="24" v-show="getGlobalConfig().isDev">
            <el-form-item label="企业名称">
              <el-input v-model="form.compMc" placeholder="请输入企业名称" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业简码" prop="compQyjm">
              <el-input v-model="form.compQyjm" :disabled="true" placeholder="请输入企业简码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出栏批次号" prop="slauBatchNum">
              <el-input v-model="form.slauBatchNum"  placeholder="请输入出栏批次号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="养殖批次号" prop="batchNum">
              <el-input v-model="form.batchNum"  placeholder="请输入养殖批次号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="屠宰批次号" prop="tzBatchNum">
              <el-input v-model="form.tzBatchNum"  placeholder="请输入屠宰批次号"></el-input>
            </el-form-item>
          </el-col>-->
          <el-col :span="12">
            <el-form-item label="出栏原因" prop="slauClyy">
              <enuSelect style="width:100%;" filterable v-model="form.slauClyy" :disabled="disabled" :list='slauClyyList' placeholder="请输入出栏原因"></enuSelect>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出栏数量" prop="slauClsl">
              <el-input-number v-model="form.slauClsl" :disabled="disabled" :min="0" placeholder="请输入出栏数量"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出栏时间" prop="slauClrq">
              <el-date-picker v-model="form.slauClrq" type="date" :disabled="disabled" editable placeholder="请输入出栏时间" value-format="yyyy-MM-dd" style="width: 100%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出栏操作人" prop="slauCzr">
              <el-input v-model="form.slauCzr" :disabled="disabled" placeholder="请输入出栏操作人"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="出栏照片">
              <card-upload v-model="fileList1" :limit="1" accept=".png,.jpg" ref="uploadFile1"></card-upload>
            </el-form-item>
          </el-col>
<!--          <el-col :span="12">
            <el-form-item label="是否已写入" prop="slauSfyxr">
              <enuSelect style="width:100%;" filterable v-model="form.slauSfyxr" :list='slauSfyxrList' placeholder="请输入是否已写入"></enuSelect>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="二维码地址" prop="slauEwm">
              <el-input v-model="form.slauEwm"  placeholder="请输入二维码地址"></el-input>
            </el-form-item>
          </el-col>-->
        </el-row>

      </el-form>
    </template>

    <span slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="confirm" v-show="!disabled">确 定</el-button>
        </span>
  </BaseDialog>
</template>

<script>
export default {
  name: "infoDialog",
  props: {
    infoDialogConfig: {
      type: Object,
      default: () => {
      },
    },
    infoDialogVisible: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      fileList1: [],
      form: {
        slauId: '',
        compId: '',
        compBh: '',
        compMc: '',
        compQyjm: '',
        slauBatchNum: '',
        batchNum: '',
        tzBatchNum: '',
        slauClyy: '',
        slauClsl: '',
        slauCzr: '',
        slauClrq: '',
        slauSfyxr: '',
        slauEwm: '',
        createTime: '',
        createUserId: '',
        createUserName: '',
        slauTp: '',
      },
      rules: {
        compQyjm: [{
          required: true,
          message: "请输入企业简码",
          trigger: "submit",
        },],/*
        slauBatchNum: [{
          required: true,
          message: "请输入出栏批次号",
          trigger: "submit",
        },],
        batchNum: [{
          required: true,
          message: "请输入养殖批次号",
          trigger: "submit",
        },],
        tzBatchNum: [{
          required: true,
          message: "请输入屠宰批次号",
          trigger: "submit",
        },],*/
        slauClyy: [{
          required: true,
          message: "请输入出栏原因",
          trigger: "submit",
        },],
        slauClsl: [{
          required: true,
          message: "请输入出栏数量",
          trigger: "submit",
        },],
        slauClrq: [{
          required: true,
          message: "请输入出栏时间",
          trigger: "submit",
        },],/*
        slauCzr: [{
          required: true,
          message: "请输入出栏操作人",
          trigger: "submit",
        },],
        slauSfyxr: [{
          required: true,
          message: "请输入是否已写入",
          trigger: "submit",
        },],
        slauEwm: [{
          required: true,
          message: "请输入二维码地址",
          trigger: "submit",
        },],*/
      },
      options: [],
      dialogVisible: false,
      disabled:false,
      //企业名称
      compList: [],
      //出栏原因
      slauClyyList: [],
      //是否已写入
      slauSfyxrList: [],
    };
  },
  computed: {},
  mounted() {
    this.slauClyyList = this.infoDialogConfig.slauClyyList;
    this.slauSfyxrList = this.infoDialogConfig.slauSfyxrList;
    this.form.batchNum = this.infoDialogConfig.batchNum;
    if (this.infoDialogConfig.data) {
      for (const key in this.infoDialogConfig.data) {
        for (const k in this.form) {
          if (key === k) {
            this.form[k] = this.infoDialogConfig.data[key];
          }
        }
      }
      if (this.form.slauTp) {
        let slauTp = this.form.slauTp.split(",");
        slauTp.map(item => {
          this.fileList1.push({
            fileId: item
          });
        })
      }
    }
    this.form.compId = this.infoDialogConfig.compId_g;
    this.form.compMc = this.infoDialogConfig.compMc_g;
    if (!this.form.slauClrq){
      this.form.slauClrq = this.getNowDate();
    }
    if (!this.form.slauCzr){
      this.form.slauCzr = JSON.parse(sessionStorage.getItem('user')).realName;
    }
    this.disabled = this.infoDialogConfig.disabled;
  },

  methods: {
    //获取当前日期
    getNowDate() {
      var time = new Date();
      var day = ("0" + time.getDate()).slice(-2);
      var month = ("0" + (time.getMonth() + 1)).slice(-2);
      var today = time.getFullYear() + "-" + month + "-" + day;
      return today;
    },

    close() {
      this.$emit("update:infoDialogVisible", false);
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.form));
          if (this.fileList1.length > 0) {
            let slauTp = [];
            this.fileList1.map(item => {
              slauTp.push(item.fileId);
            })
            params.slauTp = slauTp.join(",");
          } else {
            params.slauTp = '';
          }
          delete params.fileList1;
          if (params.slauId) {
            this.$api
              .formPost("/api/major/tz/slaugh/doModById", params)
              .then((res) => {
                this.$message.success("操作成功");
                this.close();
                this.$emit("onSuccess");
              });
          } else {
            delete params.slauId;
            this.$api
              .formPost("/api/major/tz/slaugh/doSave", params)
              .then((res) => {
                this.$message.success("操作成功");
                this.close();
                this.$emit("onSuccess");
              });
          }
        }
      });
    },

  },
};
</script>

<style lang="scss" scoped>
.userInfo {
  width: 240px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .info {
    font-size: var(--text-size);
    display: flex;
    justify-content: space-between;
    padding: 13px 0px;
    border-bottom: 1px solid #ccc;

    .title {
      min-width: 70px;
    }
  }
}

.avatar-uploader {
  width: 100%;
  border: 1px dotted #ccc;
  text-align: center;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 240px;
  height: 240px;
  line-height: 240px;
  text-align: center;
}

.avatar {
  width: 240px;
  height: 240px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/outSheep/components/infoDialog.vue